<template>
    <div class="flex items-center flex-no-shrink text-white mr-6">
        <img src="./../assets/ibestica.svg" alt="Ibestica Logo" class="block h-12 mr-6" >
        <span class="font-bold text-3xl font-sans -mb-2">Ibestica</span>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>